// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

if (!Object.values) {
  Object.values = function (obj) {
    var values = Object.keys(obj).map(function(e) {
      return obj[e]
    });

    return values;
  };
}


//////////////////
// WEBPACK FOOTER
// ./config/polyfills/values.js
// module id = 207
// module chunks = 0